import React from "react"
import { Button, Modal } from "antd"

const CenteredPaperModal = ({
  open,
  onClose,
  width = 800,
  children,
  sx = {},
  ...rest
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      onClose={onClose}
      footer={null}
      centered
      width={width}
      {...rest}
      style={{
        maxWidth: "90vw",
        maxHeight: "90vh",
        overflow: "auto",
        borderRadius: 8,
        ...sx,
      }}
      closeIcon={
        <Button variant="text" type="text" icon={<i className="ri-close-line" />} />
      }
    >
      {children}
    </Modal>
  )
}

export default CenteredPaperModal
